import React, {createContext, useContext, useEffect, useState} from "react";
import apiService from "../services/apiService";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        if (!settings) {
            apiService
                .getSettings()
                .then((response) => {
                    if (response.data.length) {
                        const newSettings = response.data[0];
                        setSettings(newSettings);
                    }
                })
                .catch((err) => {
                    console.error("Failed to fetch settings:", err);
                });
        }
    }, [settings]); // The effect will only run when settings are not already fetched

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    return useContext(SettingsContext);
};
